import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { LoadingController, ToastController } from '@ionic/angular';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute  } from '@angular/router';
import jwt_decode from "jwt-decode";
import { BackendService } from '../core/services/backend-prod.service';
import { SessionService } from '../core/services/session.service';
import { HelperService } from '../core/services/helper.service';

@Component({
  selector: 'app-verify-code',
  templateUrl: './verify-code.page.html',
  styleUrls: ['./verify-code.page.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VerifyCodePage implements OnInit {
  verifyCodeform: UntypedFormGroup;
  submitted: boolean = false;
  token: any;
  verifyemail: string;
  sendCodeApi: any;

  constructor(
    private title: Title,
    private fb: UntypedFormBuilder,
    private backendService: BackendService,
    private sessionService: SessionService,
    private router: Router,
    private route: ActivatedRoute,
    public toastController: ToastController,
    public loadingController: LoadingController,
    public helperService: HelperService
  ) { }


 async ngOnInit() {
    this.title.setTitle('eZintegrations | Verify Code ');
    this.sessionService.clearStorage();
    this.verifyCodeform = this.fb.group({
      'verifyCode': ['', Validators.required],
    });
    this.route.queryParams
      .subscribe(params => {
        this.token = params.data;
      }
    );
    var decodeToken: any =await this.getDecodeToken(this.token);
    // console.log(decodeToken);
    if(decodeToken) {
      var refId = decodeToken.id;
      var refemail = decodeToken.email;
      let sendCodeObj = {id: refId, email : refemail};
      this.helperService.loader();
      this.sendCodeApi = this.backendService.Post('sendCode', sendCodeObj)
      .subscribe(
        data => {
          this.helperService.closeLoader().then(()=>{
            this.helperService.presentToast(data.msg, 2000);
          })
        },
        error => {
          this.helperService.closeLoader().then(()=>{
            this.helperService.handleError(error);
          })
        }
      );
      this.verifyCodeform.addControl('refId', this.fb.control(refId));
      this.verifyCodeform.addControl('email', this.fb.control(refemail));
      this.verifyemail = refemail;
    }
  }
  get verifyCodeControls() { return this.verifyCodeform.controls; }

  onVerifyCodeSubmit() {
    this.submitted = true;
    // //console.log(this.verifyCodeform.value);
    if (this.verifyCodeform.invalid) {
      return;
    }

    let getCodeObj = {
      id: this.verifyCodeform.value.refId,
      email : this.verifyCodeform.value.email.trim()
    };
    this.helperService.loader();
    this.backendService.Post('getCode', getCodeObj)
      .subscribe(
        data => {
          this.helperService.closeLoader().then(()=>{
            this.route.queryParams.subscribe(params => {
              this.token = params.data;
            });
            if(this.verifyCodeform.value.verifyCode == data.code) {
              this.submitted = false;
              this.helperService.presentToast('Verification done successfully', 2000);
              this.router.navigate(['/set-password'],{ queryParams: { data :  this.token} });
              // this.router.navigate(['set-password']);
            } else {
              this.helperService.presentToast('Verification code invalid', 2000);
              // this.verifyCodeControls['verifyCode'].setValidators([Validators.required]);
            }
          })
        },
        error => {
          this.helperService.closeLoader().then(()=>{
            this.helperService.handleError(error);
          })
        }
    );
  }
  
  async getDecodeToken (token: any) {
    if(token) {
      var decoded;
      await this.helperService.decode(token).then((d)=>{decoded=d});
      return decoded;
    }
    return;
  }

  resendVerifyCode () {
    let reSendCodeObj = {id: this.verifyCodeform.value.refId, email : this.verifyCodeform.value.email.trim()};
    this.backendService.Post('sendCode', reSendCodeObj)
    .subscribe(
      data => {
        this.helperService.presentToast(data.msg, 2000);
      },
      error => {
        this.helperService.handleError(error);
      }
    );
  }

  ngOnDestroy(){
    this.sendCodeApi.unsubscribe();
    this.helperService.closeLoader();
  }

}
